export enum AuthorityCustomer {
  REGISTER_CUSTOMER_ACTIVE_INACTIVE = '1.3.6',
  REGISTER_CUSTOMER_REPORTS = '1.3.5',
  REGISTER_CUSTOMER_EDIT = '1.3.4',
  REGISTER_CUSTOMER_DELETE = '1.3.3',
  REGISTER_CUSTOMER_ADD = '1.3.2',
  REGISTER_CUSTOMER_VIEW = '1.3.1',
  REGISTER_CUSTOMER_REGISTRATION = '1.3',
}
